export default {
  title: {
    en: 'Please login first'
  },

  text: {
    en: "To participate in this promotion you must be logged in with your McDonald's account."
  },

  button: {
    en: 'Login'
  }
};
